<app-stock-criteria-table></app-stock-criteria-table>
